module.exports = __webpack_public_path__ + "img/透明猪.97b6fba5.png";